export function toggleCheckboxes(selector, checked)
{
    var checkboxes = document.querySelectorAll(selector);

    for(var i = 0; i < checkboxes.length; i++) {
        if(!checkboxes[i].disabled) {
            checkboxes[i].checked = checked;
        }
    }
}
